import styled from 'styled-components';
import { THEME } from '../../../../../../../../themes';
import { CaptionFont } from '../../../../../../../../themes/fonts';
import { ASSETS } from '../../../../../../../../assets';
import { hexToRgbA } from '../../../../../../../../utils/colors';

export const PromotedBadgeContainer = styled.div`
  border-radius: ${THEME.RADIUS.TIDY};
  border: solid 1px ${hexToRgbA(THEME.COLORS.WARNING, THEME.OPACITY.LOW)};
  background-color: ${hexToRgbA(THEME.COLORS.WARNING, THEME.OPACITY.DIVIDER)};
  padding: 0 8px;
  text-align: center;
  :before {
    content: url(${ASSETS.CHART_UP});
    margin-right: ${THEME.SPACING.MICRO};
}
`;

export const PromotionLabel = styled.span`
  ${CaptionFont};
  font-weight: 500;
  line-height: 1.83;
  letter-spacing: 0.21px;
`;
